import React from 'react';
import './App.css';
import OIcon from './components/OIcon';
import XIcon from './components/XIcon';
import { Link } from 'react-router-dom';

function App() {
    return (
        <div className="flex h-screen flex-col items-center justify-center bg-gray-50">
            <div className="flex">
                <XIcon className="h-24 w-24"></XIcon>
                <OIcon className="h-24 w-24"></OIcon>
            </div>

            <Link
                to="/choose"
                className="mt-24 rounded-full bg-blue-500 py-2 px-6 text-white shadow-lg transition duration-100 hover:bg-blue-400 focus:bg-blue-600"
            >
                Play with AI
            </Link>

            <footer className="fixed bottom-0 p-4">
                Created By:{' '}
                <a
                    href="https://malhalwachi.com"
                    className="underline hover:text-gray-500"
                >
                    Mohammed Alhalwachi
                </a>
            </footer>
        </div>
    );
}

export default App;
